import { useQuery } from '@tanstack/react-query';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { getCategories } from 'src/api/getCategories/getCategories';

export const useCategories = (menuId: string) => {
  const { showSnackbar } = useSnackbar();

  return useQuery({
    queryKey: ['categories', menuId],
    queryFn: async () => {
      return await getCategories(menuId);
    },
    onError: () => showSnackbar({ status: SnackbarStatus.ERROR, message: 'Internal Server Error' }),
  });
};
